import React, { createContext, useReducer, useContext, useEffect } from "react";
import { useCompanyStore } from "../companyStore/companyStore";
import { organizationalStructureActions } from "./organizationalStructureStore.actions";
import {
  OrganizationalStructureActions,
  organizationalStructureInitState,
  OrganizationalStructureState,
  organizationalStructureStateReducer,
} from "./organizationalStructureStore.reducers";
import { Api } from "services/api/api.service";

export type OrganizationalStructureDispatch = (
  action: OrganizationalStructureActions
) => void;

const OrganizationalStructureStateContext = createContext<
  OrganizationalStructureState | undefined
>(undefined);
const OrganizationalStructureDispatchContext = createContext<
  OrganizationalStructureDispatch | undefined
>(undefined);

export const OrganizationalStructureStoreProvider: React.FC = ({
  children,
}) => {
  const [state, dispatch] = useReducer(
    organizationalStructureStateReducer,
    organizationalStructureInitState
  );
  const [companyState] = useCompanyStore();

  useEffect(() => {
    if (companyState.company) {
      dispatch({ type: "SET_IS_LOADING", payload: true });
      Api()
        .company.organizationalStructure.fetchCompanyStructure(
          companyState.company.id
        )
        .then((res) => {
          dispatch({
            type: "GET_COMPANY_STRUCTURE",
            payload: res.data,
          });
          dispatch({ type: "SET_IS_LOADING", payload: false });
        })
        .catch(() => {
          dispatch({ type: "SET_IS_LOADING", payload: false });
        });
    }
  }, [companyState.company]);

  return (
    <OrganizationalStructureStateContext.Provider value={state}>
      <OrganizationalStructureDispatchContext.Provider value={dispatch}>
        {children}
      </OrganizationalStructureDispatchContext.Provider>
    </OrganizationalStructureStateContext.Provider>
  );
};

export const useOrganizationalStructureStore = () => {
  const state = useContext(OrganizationalStructureStateContext);
  const dispatch = useContext(OrganizationalStructureDispatchContext);

  if (state === undefined || dispatch === undefined) {
    throw new Error(
      "useOrgStructureStore must be used within a OrganizationalStructureStoreProvider"
    );
  }

  const actions = organizationalStructureActions(dispatch, state);
  return [state, actions, dispatch] as const;
};
